const getUrlWithProtocol = url => {
  if (url.startsWith('https://')) return url;
  if (url.startsWith('http://')) return `https://${url.slice(7)}`;
  if (url.startsWith('//')) return `https:${url}`;
  return url;
};
export { getUrlWithProtocol };
//# sourceMappingURL=getUrlWithProtocol.js.map
